import React, { useEffect, useState } from "react";
import styled from "styled-components";
import BackButton from "../Button/BackButton";

const DesktopPage = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f1f2f6;
`;

const DesktopHeader = styled.div`
  width: 100%;
  height: 60px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  background: #ffffff;
  color: #1f2433;
  padding: 12px 16px;
  gap: 8px;
  box-shadow: 0 1px 0 #eee;
  box-sizing: border-box;
`;

const DesktopTitle = styled.div`
  font-size: 17px;
  font-weight: 700;
  line-height: normal;
`;

const DesktopBody = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px 32px 64px;
  box-sizing: border-box;
`;

const DesktopContent = styled.div`
  width: min(100%, 1180px);
`;

const NoticeCard = styled.div`
  width: min(100%, 820px);
  border-radius: 16px;
  background: #ffffff;
  color: #17171d;
  padding: 52px 56px;
  margin: 0 auto;
  box-shadow: 0 8px 24px rgba(31, 36, 51, 0.06);
  box-sizing: border-box;
`;

const NoticeTitle = styled.div`
  font-size: 20px;
  font-weight: 800;
  line-height: 1.25;
  margin-bottom: 28px;
`;

const NoticeBody = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 1.35;
`;

const isDesktopViewport = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(min-width: 768px)").matches;

const BidsDesktopNotice = ({
  children,
  title = "Bids",
  backPath = "/bids/all",
}) => {
  const [isDesktop, setIsDesktop] = useState(isDesktopViewport);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 768px)");
    const handleChange = () => setIsDesktop(mediaQuery.matches);

    handleChange();
    mediaQuery.addEventListener("change", handleChange);

    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);

  if (isDesktop) {
    return (
      <DesktopPage>
        <DesktopHeader>
          <BackButton pathName={backPath} />
          <DesktopTitle>{title}</DesktopTitle>
        </DesktopHeader>
        <DesktopBody>
          <DesktopContent>
            <NoticeCard>
              <NoticeTitle>Mobile Device Required</NoticeTitle>
              <NoticeBody>
                Please use a mobile device to continue bidding. We will be back
                in web shortly!
              </NoticeBody>
            </NoticeCard>
          </DesktopContent>
        </DesktopBody>
      </DesktopPage>
    );
  }

  return children;
};

export default BidsDesktopNotice;
